module.exports = __webpack_public_path__ + "static/media/Trackandtrace.73441090.svg";